import { type CrossClientQueryExecution, type CrossClientQueryResultStatus, CrossClientQueryResultStatuses } from '../../../../models/CrossClient'

type ProgressStatuses = Partial<Record<CrossClientQueryResultStatus, number>>

const finishedFrom = (statuses: ProgressStatuses): number =>
  (statuses[CrossClientQueryResultStatuses.SUCCEEDED] ?? 0) +
  (statuses[CrossClientQueryResultStatuses.NO_DATA] ?? 0) +
  (statuses[CrossClientQueryResultStatuses.FAILED] ?? 0)

export const computeRunningProgress = (execution: CrossClientQueryExecution, statuses: ProgressStatuses | undefined): { done: number; total: number } => {
  const total = execution.resultCount
  if (!statuses) {
    return { done: 0, total }
  }
  return { done: finishedFrom(statuses), total }
}
